import {
  Component,
  EventEmitter,
  Input,
  Output,
  booleanAttribute,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from 'app/core/services/auth.service';
import { ToastService } from 'app/core/services/toast.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-microsoft-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './microsoft-button.component.html',
  styleUrls: ['./microsoft-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MicrosoftButtonComponent {
  @Input() label = 'Entrar com Microsoft';
  @Input({ transform: booleanAttribute }) fullWidth = false;
  @Input({ transform: booleanAttribute }) usePopup = false;
  @Output() loginSuccess = new EventEmitter<void>();
  @Output() loginError = new EventEmitter<string>();

  private readonly authService = inject(AuthService);
  private readonly toastService = inject(ToastService);
  private readonly route = inject(ActivatedRoute);

  isLoading = signal(false);

  async handleMicrosoftLogin(): Promise<void> {
    if (!this.authService.isMicrosoftOAuthEnabled()) {
      this.toastService.showErrorToast(
        'OAuth Indisponível',
        'OAuth Microsoft não está disponível neste ambiente',
      );
      return;
    }

    this.isLoading.set(true);

    try {
      const returnUrl = this.route.snapshot.queryParams['returnUrl'] as
        | string
        | undefined;

      if (this.usePopup) {
        const result = await this.authService.loginWithMicrosoft({
          popup: true,
          redirectUrl: returnUrl,
        });
        if (result) {
          this.toastService.showSuccessToast(
            'Login realizado!',
            'Bem-vindo de volta!',
          );
          this.loginSuccess.emit();
          this.authService.navegarAposLogin();
        }
      } else {
        this.authService.loginWithMicrosoft({
          popup: false,
          redirectUrl: returnUrl,
        });
      }
    } catch (error) {
      this.isLoading.set(false);
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Erro ao fazer login com Microsoft';
      this.toastService.showErrorToast('Erro na Autenticação', errorMessage);
      this.loginError.emit(errorMessage);
    }
  }
}
